export enum FormField {
  name = 'name',
  address = 'address',
  phone_number = 'phone_number',
  client_access_code = 'client_access_code',
}
